import axios from 'axios'
import { getBearerToken } from 'shared/auth/auth.utils'
import { appConfig } from 'src/config/app-config'

export const LuigiClient = axios.create({
    baseURL: appConfig.luigiApiBaseUrl,
    headers: {
        'X-Caller-Service': 'experts-client',
        'x-vault-key': 'fts-data',
    },
})

LuigiClient.interceptors.request.use(config => {
    const token = getBearerToken()
    if (token) {
        config.headers.Authorization = token
    }
    return config
}, Promise.reject)
